import { useLocation, useNavigate } from 'react-router-dom'
import { Home, Zap, MessageSquare, User } from 'lucide-react'

const NAV_ITEMS = [
  { path: '/briefing', label: '首页', icon: Home },
  { path: '/toplist', label: '龙虎榜', icon: Zap },
  { path: '/', label: 'AI 诊股', icon: MessageSquare },
  { path: '/me', label: '我的', icon: User },
] as const

export default function BottomNav() {
  const location = useLocation()
  const navigate = useNavigate()

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/' || location.pathname === '/agent'
    return location.pathname.startsWith(path)
  }

  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        borderTop: '1px solid var(--color-border)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
      className="bg-bg-elevated/95 backdrop-blur-md"
      role="navigation"
      aria-label="主导航"
    >
      <div
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', height: 56, maxWidth: 480, margin: '0 auto' }}
      >
        {NAV_ITEMS.map(({ path, label, icon: Icon }) => {
          const active = isActive(path)
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, minWidth: 48, minHeight: 48 }}
              className={`transition-colors duration-150 cursor-pointer
                         ${active ? 'text-primary' : 'text-text-muted'}`}
              aria-label={label}
              aria-current={active ? 'page' : undefined}
            >
              <Icon style={{ width: 22, height: 22 }} strokeWidth={active ? 2.2 : 1.8} />
              <span style={{ fontSize: 10, lineHeight: 1 }} className={active ? 'font-semibold' : 'font-medium'}>
                {label}
              </span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}
